export default "__VITE_ASSET__b7b32103__"